import { DefaultSpinner } from "components/loading/DefaultSpinner";
import { SPINNER_SIZES } from "components/loading/defaultSpinner.consts";

export const DicomPageLoader = () => (
  <div className="viewer-loading-overlay">
    <DefaultSpinner spinnerSize={SPINNER_SIZES.LARGE} />
  </div>
);
